import { init, loadRemote, registerRemotes } from '@module-federation/runtime'
import * as VueRuntime from 'vue'
import type { Component } from 'vue'
import { resolveSaasRemoteName } from '../utils/menuArchitecture'
import type { ModuleMenuItem } from '../types'

const loadedRemotes = new Map<string, string>()

init({
  name: 'saas_shell',
  remotes: [],
  shared: {
    vue: {
      version: '3.5.38',
      lib: () => VueRuntime,
      shareConfig: {
        singleton: true,
        requiredVersion: '^3.5.0'
      }
    }
  }
})

export function remoteNameFor(menu: ModuleMenuItem) {
  return resolveSaasRemoteName(menu.moduleCode)
}

export async function loadModuleComponent(menu: ModuleMenuItem) {
  const remoteName = remoteNameFor(menu)
  if (loadedRemotes.get(remoteName) !== menu.remoteEntry) {
    registerRemotes(
      [
        {
          name: remoteName,
          entry: menu.remoteEntry,
          entryGlobalName: remoteName,
          type: 'module',
          shareScope: 'default'
        }
      ],
      { force: true }
    )
    loadedRemotes.set(remoteName, menu.remoteEntry)
  }

  const exposePath = menu.exposedModule.replace(/^\.\//, '')
  const remoteModule = await loadRemote<{ default: Component }>(`${remoteName}/${exposePath}`)
  if (!remoteModule?.default) {
    throw new Error(`远端模块未导出默认 Vue 组件: ${remoteName}/${exposePath}`)
  }
  return remoteModule.default
}
